import { render, staticRenderFns } from "./charactorManager.vue?vue&type=template&id=2606f9ca&scoped=true&"
import script from "./charactorManager.vue?vue&type=script&lang=js&"
export * from "./charactorManager.vue?vue&type=script&lang=js&"
import style0 from "./charactorManager.vue?vue&type=style&index=0&id=2606f9ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606f9ca",
  null
  
)

export default component.exports